import { render, staticRenderFns } from "./logoanzeige.vue?vue&type=template&id=070d5c93&scoped=true&"
import script from "./logoanzeige.vue?vue&type=script&lang=js&"
export * from "./logoanzeige.vue?vue&type=script&lang=js&"
import style0 from "./logoanzeige.vue?vue&type=style&index=0&id=070d5c93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070d5c93",
  null
  
)

export default component.exports